import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent2"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code2-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code2-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Soft Badges", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab2",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview2-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview2-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview2-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code2-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code2-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code2-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview2-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview2-tab",
          tabindex: "0"
        }, [
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-primary py-1 px-2 me-1 text-primary rounded-1 fw-medium fs-12" }, "Primary"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-secondary py-1 px-2 me-1 text-secondary rounded-1 fw-medium fs-12" }, "Secondary"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-secondary py-1 px-2 me-1 text-secondary rounded-1 fw-medium fs-12" }, "Success"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-danger py-1 px-2 me-1 text-danger rounded-1 fw-medium fs-12" }, "Danger"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-warning py-1 px-2 me-1 text-warning rounded-1 fw-medium fs-12" }, "Warning"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-info py-1 px-2 me-1 text-info rounded-1 fw-medium fs-12" }, "Info"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-light py-1 px-2 me-1 text-light rounded-1 fw-medium fs-12" }, "Light"),
          _createElementVNode("span", { class: "badge bg-opacity-10 bg-dark py-1 px-2 me-1 text-dark rounded-1 fw-medium fs-12" }, "Dark")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<span class=\"badge bg-opacity-10 bg-primary py-1 px-2 text-primary rounded-1 fw-medium fs-12\">Primary</span>\n<span class=\"badge bg-opacity-10 bg-secondary py-1 px-2 text-secondary rounded-1 fw-medium fs-12\">Secondary</span>\n<span class=\"badge bg-opacity-10 bg-secondary py-1 px-2 me-1 text-secondary rounded-1 fw-medium fs-12\">Success</span>\n<span class=\"badge bg-opacity-10 bg-danger py-1 px-2 text-danger rounded-1 fw-medium fs-12\">Danger</span>\n<span class=\"badge bg-opacity-10 bg-warning py-1 px-2 text-warning rounded-1 fw-medium fs-12\">Warning</span>\n<span class=\"badge bg-opacity-10 bg-info py-1 px-2 text-info rounded-1 fw-medium fs-12\">Info</span>\n<span class=\"badge bg-opacity-10 bg-light py-1 px-2 text-light rounded-1 fw-medium fs-12\">Light</span>\n<span class=\"badge bg-opacity-10 bg-dark py-1 px-2 text-dark rounded-1 fw-medium fs-12\">Dark</span>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}